import { createViewMonthGrid, createViewWeek } from "@schedule-x/calendar";
import { createEventModalPlugin } from "@schedule-x/event-modal";
import { ScheduleXCalendar, useCalendarApp } from "@schedule-x/react";
import "@schedule-x/theme-default/dist/calendar.css";
import React from "react";

function EventCalendar({ data }) {
  const calendar = useCalendarApp({
    views: [createViewMonthGrid(), createViewWeek()],
    events: data,
    locale: "en-IN",
    firstDayOfWeek: 0,
    defaultView: createViewMonthGrid,
    plugins: [createEventModalPlugin()],
  });

  // Custom style for calendar wrapper
  React.useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .sx-react-calendar-wrapper {
        
       
        height: 500px;
        max-height: 80vh;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div>
      <ScheduleXCalendar calendarApp={calendar} />
    </div>
  );
}

export default EventCalendar;
